import { useRef, type ChangeEvent } from 'react'

const AttachIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    style={{ pointerEvents: 'none' }}
  >
    <path
      d="M10.97 22.75C7.25 22.75 4.22 19.72 4.22 16V10C4.22 5.73 7.7 2.25 11.97 2.25C16.24 2.25 19.72 5.73 19.72 10V15.5C19.72 17.84 17.81 19.75 15.47 19.75C13.13 19.75 11.22 17.84 11.22 15.5V12C11.22 11.59 11.56 11.25 11.97 11.25C12.38 11.25 12.72 11.59 12.72 12V15.5C12.72 17.02 13.95 18.25 15.47 18.25C16.99 18.25 18.22 17.02 18.22 15.5V10C18.22 6.55 15.42 3.75 11.97 3.75C8.52 3.75 5.72 6.55 5.72 10V16C5.72 18.89 8.07 21.25 10.97 21.25C11.38 21.25 11.72 21.59 11.72 22C11.72 22.41 11.39 22.75 10.97 22.75Z"
      fill="currentColor"
    />
  </svg>
)

const MicIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    style={{ pointerEvents: 'none' }}
  >
    <path
      d="M12 16.25C9.38 16.25 7.25 14.12 7.25 11.5V6C7.25 3.38 9.38 1.25 12 1.25C14.62 1.25 16.75 3.38 16.75 6V11.5C16.75 14.12 14.62 16.25 12 16.25ZM12 2.75C10.21 2.75 8.75 4.21 8.75 6V11.5C8.75 13.29 10.21 14.75 12 14.75C13.79 14.75 15.25 13.29 15.25 11.5V6C15.25 4.21 13.79 2.75 12 2.75Z"
      fill="currentColor"
    />
    <path
      d="M12 19.7499C7.37 19.7499 3.6 15.9799 3.6 11.3499V9.6499C3.6 9.2399 3.94 8.8999 4.35 8.8999C4.76 8.8999 5.1 9.2399 5.1 9.6499V11.3499C5.1 15.1499 8.2 18.2499 12 18.2499C15.8 18.2499 18.9 15.1499 18.9 11.3499V9.6499C18.9 9.2399 19.24 8.8999 19.65 8.8999C20.06 8.8999 20.4 9.2399 20.4 9.6499V11.3499C20.4 15.9799 16.63 19.7499 12 19.7499Z"
      fill="currentColor"
    />
    <path
      d="M13.39 7.18007C13.31 7.18007 13.22 7.17007 13.13 7.14007C12.4 6.87007 11.6 6.87007 10.87 7.14007C10.48 7.28007 10.05 7.08007 9.91 6.69007C9.77 6.30007 9.97 5.87007 10.36 5.73007C11.42 5.35007 12.59 5.35007 13.65 5.73007C14.04 5.87007 14.24 6.30007 14.1 6.69007C13.98 6.99007 13.69 7.18007 13.39 7.18007Z"
      fill="currentColor"
    />
    <path
      d="M12.8 9.30007C12.73 9.30007 12.67 9.29007 12.6 9.27007C12.2 9.16007 11.79 9.16007 11.39 9.27007C10.99 9.38007 10.58 9.14007 10.47 8.74007C10.36 8.35007 10.6 7.94007 11 7.83007C11.65 7.65007 12.35 7.65007 13 7.83007C13.4 7.94007 13.64 8.35007 13.53 8.75007C13.44 9.08007 13.13 9.30007 12.8 9.30007Z"
      fill="currentColor"
    />
    <path
      d="M12 22.75C11.59 22.75 11.25 22.41 11.25 22V19C11.25 18.59 11.59 18.25 12 18.25C12.41 18.25 12.75 18.59 12.75 19V22C12.75 22.41 12.41 22.75 12 22.75Z"
      fill="currentColor"
    />
  </svg>
)

const iconBtnStyle = {
  width: 27,
  height: 27,
  borderRadius: 7,
  border: '1px solid var(--bd)',
  display: 'flex' as const,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  cursor: 'pointer' as const,
  fontSize: 13,
  color: 'var(--muted)',
  position: 'relative' as const,
  background: 'transparent',
  flexShrink: 0,
  padding: 0,
}

type AttachFileButtonProps = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const AttachFileButton = ({ onChange }: AttachFileButtonProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,.doc,.docx,.xlsx,.xls,.png,.jpg,.jpeg"
        onChange={onChange}
        tabIndex={-1}
        style={{ display: 'none' }}
      />
      <button
        type="button"
        className="input-bar-icon-btn"
        title="Upload"
        aria-label="Upload file"
        onClick={() => inputRef.current?.click()}
        style={iconBtnStyle}
      >
        <AttachIcon />
      </button>
    </>
  )
}

type MicButtonProps = {
  isRecording: boolean
  onClick: () => void
}

export const MicButton = ({ isRecording, onClick }: MicButtonProps) => (
  <button
    type="button"
    title="Voice"
    aria-label={isRecording ? 'Stop voice input' : 'Start voice input'}
    className={`input-bar-icon-btn ${isRecording ? 'input-bar-icon-btn-recording' : ''}`}
    onClick={() => onClick()}
    style={{
      ...iconBtnStyle,
      background: isRecording ? 'rgba(239, 68, 68, 0.1)' : 'transparent',
      color: isRecording ? '#EF4444' : 'var(--muted)',
      zIndex: 1,
    }}
  >
    <MicIcon />
    {isRecording && (
      <span
        style={{
          position: 'absolute',
          top: -2,
          right: -2,
          width: 6,
          height: 6,
          borderRadius: '50%',
          background: '#EF4444',
          pointerEvents: 'none',
        }}
      />
    )}
  </button>
)

type ComposerIconActionsProps = {
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => void
  speechSupported?: boolean
  isRecording: boolean
  onMicClick: () => void
  showHint?: boolean
}

export const ComposerIconActions = ({
  onFileChange,
  isRecording,
  onMicClick,
  showHint = true,
}: ComposerIconActionsProps) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 5, position: 'relative', zIndex: 2 }}>
    <AttachFileButton onChange={onFileChange} />
    <MicButton isRecording={isRecording} onClick={onMicClick} />
    {showHint && (
      <span style={{ fontSize: 10, color: 'var(--muted2)' }}>Shift + Enter for new line</span>
    )}
  </div>
)
